import * as React from 'react';

export default () => (
  <svg viewBox='0 0 19 13'>
    <path d='M5.4,13H0V3.5h5.4V13z M1,12h3.4V4.5H1V12z M19,13h-5.4V3.5H19V13z M14.6,12H18V4.5h-3.4V12z M12.2,13H6.8V6.2h5.4V13z M7.8,12h3.4V7.2H7.8V12z' />
  </svg>
);
